module.exports = __webpack_public_path__ + "915ed46330f72d0e10bf652bb3e9c6d5.MP3";